import { MenuItem } from 'primeng/api';
import { TaxonomyFeature } from '../../models/TaxonomyFeature';
import { TaxonomyTab } from '../../models/TaxonomyTab';

export class CampaignTableConstants {
  private static readonly unmapCampaignAction: MenuItem = {
    id: 'unmap-campaign',
    label: '<span class="b1 text-gray-1000">Unmap campaign</span>',
    escape: false,
    styleClass: 'transition-none'
  };

  private static readonly editMappingAction: MenuItem = {
    id: 'edit-mapping',
    label: '<span class="b1 text-gray-1000">Edit mapping</span>',
    escape: false,
    styleClass: 'transition-none'
  };

  private static readonly approveMappingAction: MenuItem = {
    id: 'approve-mapping',
    label: '<span class="b1 text-gray-1000">Approve mapping</span>',
    escape: false,
    styleClass: 'transition-none'
  };

  public static unmappedCampaignActions: MenuItem[] = [this.editMappingAction];

  public static mappedCampaignActions: MenuItem[] = [
    this.editMappingAction,
    this.unmapCampaignAction
  ];

  public static aiRecommendationsCampaignActions: MenuItem[] = [
    this.approveMappingAction,
    this.editMappingAction
  ];

  public static readonly delayForClearingSelectedCampaignInMillis = 500;

  public static readonly actionMenuItems: Record<string, MenuItem[]> = {
    [TaxonomyTab.unmapped]: this.unmappedCampaignActions,
    [TaxonomyTab.mapped]: this.mappedCampaignActions,
    [TaxonomyTab.underProcessing]: this.mappedCampaignActions,
    [TaxonomyFeature.AI]: this.aiRecommendationsCampaignActions
  };
}
